import React from 'react'
import blogImg111 from '../assets/blogImg111.png'



// ✅ Reusable Component (moved outside)
const BlogSectionTop = (props) => {
    return (
         <section className="py-5 text-start" style={{ backgroundColor: 'rgb(4,180,228)', height:'60vh' }}>
            <div className="container">
                <div className="row align-items-center">
                    {/* Left Text Section */}
                    <div className="col-md-6 text-white mb-4 mb-md-0">
                        <h1 className="fw-bold display-4 text-uppercase">{props.largeHeading}</h1>
                      <p className="fs-4 mt-3">{props.smallHeading}</p>

                    </div>

                    {/* Right Image Section */}
                    <div className="col-md-6 text-center">
                        <img
                            src={blogImg111}
                            alt="Partner Illustration"
                            className="img-fluid"
                            style={{ maxHeight: '350px' }}
                        />
                    </div>
                </div>
            </div>

           

        </section>
    );
};

export default BlogSectionTop
